import React, { useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { HashLoader } from "react-spinners";
import { toast } from "react-toastify";
import { CustomForm, CustomModal } from "../../components";
import {
  useCreateUniversityMutation,
  useDeleteUniversityMutation,
  useFetchCollegesQuery,
  useFetchProfilesQuery,
  useUpdateUniversityMutation,
  useFetchAllSportsQuery,
} from "../../store/api/apiSlice";
import "../../styles/collegeManagement.css";
import { Button as CustomBtn, Input } from "../../ui";
import { queries } from "@testing-library/react";

const CollegeManagement = () => {
  const {
    data: sportsData,
    isLoading: isSportsLoading,
    refetch: refetchSportsData,
  } = useFetchAllSportsQuery();

  const {
    data: universitiesData,
    isLoading,
    error,
    refetch,
  } = useFetchCollegesQuery();
  const { data: profileData, refetch: refetchProfileData } =
    useFetchProfilesQuery();

  const [saveButton, setSaveButton] = useState(false);

  const [updateUniversity] = useUpdateUniversityMutation();
  const [totalNewsAdded, setTotalNewsAdded] = useState(0);
  const [deleteUniversity] = useDeleteUniversityMutation();
  const [createUniversity] = useCreateUniversityMutation();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedUniversity, setSelectedUniversity] = useState(null);
  const [queries, setQueries] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [uni, setUni] = useState("");
  const [sport, setSport] = useState("");
  const [buttonvisi, setButtonvisi] = useState(false);
  const [newsFetch, setNewsFetch] = useState();

  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedPublicPrivate, setSelectedPublicPrivate] = useState();
  const universityNameRef = useRef();
  const universityCommonNameRef = useRef();

  const defaultschedurl = useRef();
  const conferenceRef = useRef();
  const divisionRef = useRef();
  const reclassDivisionRef = useRef();
  const publicPrivateRef = useRef();
  const HBCURef = useRef();
  const QueeryRef = useRef();

  const stateRef = useRef();
  const customIdRef = useRef();
  const ratingRef = useRef();
  const notesRef = useRef();
  const bgColorRef = useRef();
  const fgColorRef = useRef();
  const secondaryColorRef = useRef();

  const handleInputChange2 = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      setQueries((prev) => [...prev, inputValue.trim()]);
      setInputValue("");
    }
  };
  const handleRemoveTag = (index) => {
    setQueries((prev) => prev.filter((_, i) => i !== index));
  };
  const openModal = (university = null) => {
    setSelectedUniversity(university);
    setNewsFetch(university?.get_auto_news);
    setSelectedPublicPrivate(university?.public_private);
    let parsedqueries = [];
    try {
      parsedqueries = university.queries;

      parsedqueries = parsedqueries.map((tag) => tag.trim());
    } catch (error) {
      parsedqueries = [];
    }

    setQueries(parsedqueries);
    setModalOpen(true);
    setIsCreating(!university);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedUniversity(null);
    setNewsFetch("");
    setIsCreating(false);
  };

  const handleInputChange = (e) => {
    setSelectedUniversity((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const handleQueriesChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleSubmit = async (e) => {
    setSaveButton(true);
    e.preventDefault();
    const id = selectedUniversity?._id;
    const name = universityNameRef.current.value;
    const common_name = universityCommonNameRef.current.value;
    const default_sched_url = defaultschedurl.current.value;
    const conference = conferenceRef.current.value;
    const added_by = profileData?.user.firstName;
    const division = divisionRef.current.value;
    const reclass_division = reclassDivisionRef.current.value;
    const public_private = selectedPublicPrivate;
    const HBCU = HBCURef.current.value;

    const state = stateRef.current.value;
    const custom_id = customIdRef.current.value;
    const rating = ratingRef.current.value;
    const notes = notesRef.current.value;
    const bg_color_code = bgColorRef.current.value;
    const fg_color_code = fgColorRef.current.value;
    const secondary_color_code = secondaryColorRef.current.value;
    const get_auto_news = newsFetch;

    const universityData = {
      name,
      common_name,
      default_sched_url,
      conference,
      division,
      added_by,
      reclass_division,
      public_private,
      HBCU,
      queries,
      state,
      custom_id,
      rating,
      notes,
      bg_color_code,
      fg_color_code,
      secondary_color_code,
      get_auto_news,
    };

    try {
      if (isCreating) {
        await createUniversity({ data: universityData }).unwrap();
        setSaveButton(false);
        toast.success("University created successfully!");
      } else {
        await updateUniversity({ data: universityData, id }).unwrap();
        setSaveButton(false);
        toast.success("University updated successfully!");
      }
      refetch();
      closeModal();
    } catch (error) {
      setSaveButton(false);
      toast.error("Error while saving University", error);
    }
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    try {
      await deleteUniversity({ id }).unwrap();
      refetch();
      toast.success("University deleted successfully");
    } catch (error) {
      toast.error("Error deleting university:", error);
    }
  };

  const handleUpdate = (university) => {
    openModal(university);
  };
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const filteredUniversities =
    universitiesData?.university
      ?.filter((uni) =>
        `${uni.name} ${uni.conference} ${uni.division}`
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      )
      ?.sort((a, b) => {
        if (sortOrder === "asc") {
          return a.name.localeCompare(b.name);
        } else {
          return b.name.localeCompare(a.name);
        }
      }) || [];
  const paginatedUsers = filteredUniversities.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(filteredUniversities.length / itemsPerPage);
  const getPaginationRange = () => {
    const range = [];
    const maxButtons = 10;
    const startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    const endPage = Math.min(totalPages, startPage + maxButtons - 1);

    for (let i = startPage; i <= endPage; i++) {
      range.push(i);
    }

    return range;
  };

  const paginationRange = getPaginationRange();
  const [newsvisi, setNewsvisi] = useState(false);

  const [loadingNews, setLoadingNews] = useState(false);
  const handleFetch = async (e) => {
    setLoadingNews(true);
    await NewsApi();
    setLoadingNews(false);
    setNewsvisi(true);
  };
  const handleSportChange = (e) => {
    const selectedSport = e.target.value;
    setSport(selectedSport);
    setButtonvisi(true);
  };
  const openViewModal = async (id) => {
    const xAuthToken =
      JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
    const headers = {
      "secret-key": process.env.REACT_APP_SECRET_KEY || "",
      "x-auth-token": xAuthToken,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/university/get-single/${id}`,
        {
          headers,
        }
      );
      if (response.ok) {
        const data = await response.json();
        setSelectedUniversity(data.university);
        const universityName = data?.university.name || "";
        setUni(universityName);

        setViewModalOpen(true);
      } else {
        toast.error("Failed to fetch university details.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching university details.");
    }
  };
  const NewsApi = async (id) => {
    const xAuthToken =
      JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
    const headers = {
      "secret-key": process.env.REACT_APP_SECRET_KEY || "",
      "x-auth-token": xAuthToken,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/news/google-news/serperdev?college=${uni}&query=${sport}&max_result=10`,
        {
          headers,
          method: "POST",
        }
      );
      if (response.ok) {
        const data = await response.json();
        setTotalNewsAdded(data.total_news_added);
      } else {
        toast.error("Failed to fetch university details.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching university details.");
    }
  };

  const closeViewModal = () => {
    setViewModalOpen(false);
    setSelectedUniversity(null);
    setTotalNewsAdded(0);
    setButtonvisi(false);
    setNewsvisi(false);
    setLoadingNews(false);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <HashLoader color="#00b386" size={70} />
      </div>
    );
  }

  if (error) {
    return <h1>Error loading profiles.</h1>;
  }

  return (
    <>
      <div className="d-flex justify-content-between pb-4 gap-4 pt-4">
        <Button
          variant="outline-secondary"
          className="sort-button collgeManagement_Sorting"
          onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
         
        >
          {sortOrder === "asc" ? "Sort by Descending" : "Sort by Ascending"}
        </Button>
        <Form.Control
          type="text"
          placeholder="Search by name, conference, or division..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <CustomBtn onClick={() => openModal()}>Create</CustomBtn>
      </div>
      <div className="table-container">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Official Name</th>
              <th>Conference</th>
              <th>Division</th>
              <th>Reclass Division</th>
              <th>Public/Private</th>
              <th>HBCU</th>
              <th>State</th>
              <th>Custom ID</th>
              <th>Rating</th>
              <th>Notes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedUsers.map((data) => (
              <tr
                key={data._id}
                onClick={() => openViewModal(data._id)}
                style={{ cursor: "pointer" }}
              >
                <td>{data.name}</td>
                <td>{data.conference}</td>
                <td>{data.division}</td>
                <td>{data.reclass_division}</td>
                <td>{data.public_private}</td>
                <td>{data.HBCU}</td>
                <td>{data.state}</td>
                <td>{data.custom_id}</td>
                <td>{data.rating}</td>
                <td>{data.notes}</td>
                <td>
                  <div
                  className="admin_Actions_gap"
                  >
                    <img
                      className="Update-delete-icon"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleUpdate(data);
                      }}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/create-new.png"
                      alt="create-new"
                    />
                    <img
                      className="Update-delete-icon"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleDelete(event, data._id);
                      }}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                      alt="filled-trash"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="d-flex justify-content-center mt-3">
          {paginationRange.map((page) => (
            <Button
              key={page}
              variant={currentPage === page ? "primary" : "outline-primary"}
              onClick={() => setCurrentPage(page)}
              className="mx-1"
            >
              {page}
            </Button>
          ))}
          {totalPages > 10 && currentPage + 5 < totalPages && (
            <>
              <Button
                variant="outline-primary"
                onClick={() => setCurrentPage(currentPage + 1)}
                className="mx-1"
              >
                Next
              </Button>
            </>
          )}
        </div>

        {isModalOpen && (
          <CustomModal isOpen={isModalOpen} onClose={closeModal}>
            <h3 className="modalHeading borderb">
              {isCreating ? "Create University" : "Update University"}
            </h3>
            <div className="inviteForm">
              <CustomForm onSubmit={handleSubmit} className="col-10 mx-auto">
                <div className="d-flex flex-column row">
                  <Input
                    name="name"
                    type="text"
                    value={selectedUniversity?._id}
                    ref={universityNameRef}
                    hidden
                  />
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Official Name"
                      name="name"
                      type="text"
                      value={selectedUniversity?.name}
                      ref={universityNameRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Common Name"
                      name="common_name"
                      type="text"
                      value={selectedUniversity?.common_name}
                      ref={universityCommonNameRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Default Schedule URL"
                      name="default_sched_url"
                      type="text"
                      value={selectedUniversity?.default_sched_url}
                      ref={defaultschedurl}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Conference"
                      name="conference"
                      type="text"
                      value={selectedUniversity?.conference}
                      ref={conferenceRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Division"
                      name="division"
                      type="text"
                      value={selectedUniversity?.division}
                      ref={divisionRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Reclass Division"
                      name="reclass_division"
                      type="text"
                      value={selectedUniversity?.reclass_division}
                      ref={reclassDivisionRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <label>Public/Private</label>

                    <Form.Select
                      placeholder="Public/Private"
                      name="Public/Private"
                      value={selectedPublicPrivate}
                      onChange={(e) => setSelectedPublicPrivate(e.target.value)}
                    >
                      <option value="">Public/Private</option>
                      <option value="Public">Public</option>
                      <option value="Private">Private</option>
                    </Form.Select>
                  </p>
                  <p className="fieldWrapper col-12">
                    <label>Select Auto Fetch News</label>

                    <Form.Select
                      placeholder="Select Auto Fetch News"
                      name="Select Auto Fetch News"
                      value={newsFetch}
                      onChange={(e) => setNewsFetch(e.target.value)}
                    >
                      <option value="">Select Auto Fetch News</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </Form.Select>
                  </p>

                  <p className="fieldWrapper col-12">
                    <label>Queries</label>
                    <div
                      className="collgeManagement_Queries_Main"
                    >
                      {queries.map((query, index) => (
                        <span
                          key={index}
                         className="collgeManagement_Queries_span"
                        >
                          {query}
                          <div
                            type="button"
                            className="remove-tag collgeManagement_Queries_remove"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveTag(index);
                            }}
                            
                          >
                            x
                          </div>
                        </span>
                      ))}
                      <input
                        type="text"
                        value={inputValue}
                        onChange={handleQueriesChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Query (press enter to add multiple queries)"
                        style={{
                          border: "none",
                          outline: "none",
                          flex: "1",
                          minWidth: "100px",
                          padding: "6px 18px",
                        }}
                      />
                    </div>
                  </p>

                  <p className="fieldWrapper col-12">
                    <Input
                      label="HBCU"
                      name="HBCU"
                      type="text"
                      value={selectedUniversity?.HBCU}
                      ref={HBCURef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="State"
                      name="state"
                      type="text"
                      value={selectedUniversity?.state}
                      ref={stateRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Custom ID"
                      name="custom_id"
                      type="text"
                      value={selectedUniversity?.custom_id}
                      ref={customIdRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Rating"
                      name="rating"
                      type="text"
                      value={selectedUniversity?.rating}
                      ref={ratingRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Notes"
                      name="notes"
                      type="text"
                      value={selectedUniversity?.notes}
                      ref={notesRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Background Color"
                      name="bg_color_code"
                      type="text"
                      value={selectedUniversity?.bg_color_code}
                      ref={bgColorRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Foreground Color"
                      name="fg_color_code"
                      type="text"
                      value={selectedUniversity?.fg_color_code}
                      ref={fgColorRef}
                      onChange={handleInputChange}
                    />
                  </p>
                  <p className="fieldWrapper col-12">
                    <Input
                      label="Secondary Color"
                      name="secondary_color_code"
                      type="text"
                      value={selectedUniversity?.secondary_color_code}
                      ref={secondaryColorRef}
                      onChange={handleInputChange}
                    />
                  </p>
                </div>
                <div className="btnPosition_college">
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <CustomBtn type="submit" loading={saveButton}>
                    Save
                  </CustomBtn>
                </div>
              </CustomForm>
            </div>
          </CustomModal>
        )}

        {isViewModalOpen && (
          <CustomModal isOpen={isViewModalOpen} onClose={closeViewModal}>
            <div className="collegeManagement_detail_form">
              <h3>University Details</h3>
              <p>
                <strong>Official Name:</strong> {selectedUniversity?.name}
              </p>
              <p>
                <strong>Common Name:</strong> {selectedUniversity?.common_name}
              </p>
              <p>
                <strong>Default Schedule URL:</strong>{" "}
                {selectedUniversity?.default_sched_url}
              </p>
              <p>
                <strong>Conference:</strong> {selectedUniversity?.conference}
              </p>
              <p>
                <strong>Division:</strong> {selectedUniversity?.division}
              </p>
              <p>
                <strong>Reclass Division:</strong>{" "}
                {selectedUniversity?.reclass_division}
              </p>
              <p>
                <strong>Public/Private:</strong>{" "}
                {selectedUniversity?.public_private}
              </p>
              <p>
                <strong>Get Auto News:</strong>{" "}
                {selectedUniversity?.get_auto_news ? "Yes" : "No"}
              </p>
              <p>
                <strong>Querry:</strong>{" "}
                {selectedUniversity?.queries?.join(", ")}
              </p>
              <p>
                <strong>HBCU:</strong> {selectedUniversity?.HBCU}
              </p>
              <p>
                <strong>State:</strong> {selectedUniversity?.state}
              </p>
              <p>
                <strong>Custom ID:</strong> {selectedUniversity?.custom_id}
              </p>
              <p>
                <strong>Rating:</strong> {selectedUniversity?.rating}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                {selectedUniversity?.status ? "Yes" : "No"}
              </p>
              <p>
                <strong>External File:</strong>{" "}
                {selectedUniversity?.external_file}
              </p>
              <p>
                <strong>Notes:</strong> {selectedUniversity?.notes}
              </p>
              <p>
                <strong>Background Color Code:</strong>{" "}
                {selectedUniversity?.bg_color_code}
              </p>
              <p>
                <strong>Foreground Color Code:</strong>{" "}
                {selectedUniversity?.fg_color_code}
              </p>
              <p>
                <strong>Secondary Color Code:</strong>{" "}
                {selectedUniversity?.secondary_color_code}
              </p>

              <div
             className="collegeManagement_form_sportSelect"
              >
                <div className="collegeManagement_form_select">
                  <label style={{ whiteSpace: "nowrap" }}>Select sports</label>
                  <select
                    className="form-select"
                    style={{ color: "gray" }}
                    onChange={handleSportChange}
                  >
                    <option value="">Select sports</option>

                    {sportsData?.sports.map((sport) => (
                      <option key={sport._id} value={sport.name}>
                        {sport.name}
                      </option>
                    ))}
                  </select>
                </div>
                {buttonvisi ? (
                  loadingNews ? (
                    <Button>
                      <div className="loader"></div>
                    </Button>
                  ) : (
                    <Button
                      onClick={handleFetch}
                      style={{ borderRadius: "8px" }}
                      type="button"
                    >
                      Fetch News
                    </Button>
                  )
                ) : null}
              </div>
              {!newsvisi && loadingNews ? (
                <span>Loading...</span>
              ) : newsvisi && !loadingNews ? (
                <p>
                  <strong>Total News:</strong> {totalNewsAdded}
                </p>
              ) : null}
            </div>
          </CustomModal>
        )}
      </div>
    </>
  );
};

export default CollegeManagement;
